import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateMovement'

const crateMovement = axios.create({
  baseURL
})

interceptorsSetup(crateMovement)

export default class CrateMovements {
  static async getTable (movementQuery) {
    const result = await crateMovement.get('/' + movementQuery.siteId, {
      params:
      {
        start: movementQuery.start,
        end: movementQuery.end
      }
    })
    return result.data
  }
  static async createMovement (movement) {
    const result = await crateMovement.post('/', movement)
    return result.data
  }
  static async updateMovement (movement) {
    const result = await crateMovement.post('/update', movement)
    return result.data
  }
  static async archiveMovement (movement) {
    const result = await crateMovement.put('/archive/' + movement)
    return result.data
  }
}
